import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useState } from "react";


export const EmptyLayout = () => {
    return <Outlet/>
}

export const MainLayout = () => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <>
            <Header setIsOpen={setIsOpen}/>
            <div className="flex">
                <Sidebar isOpen={isOpen}/>                
                <div className={`min-h-[calc(100vh-55px)] flex-1 bg-[#020618] p-6 mt-[55px]`}>
                    <Outlet/>
                </div>
            </div>
        </>
    )
}